module.exports = __webpack_public_path__ + "img/mobile-index-Vproject.25829840.png";